import React, { useState} from 'react';
import Layout from '../core/Layout' 
import { findManyProducts } from '../user/apiUser';
import { getOrderFromTracking, acceptVerify, denyVerify } from './apiVerify';
import { API } from '../config';
import { isAuthenticated } from '../auth';
import Error from './Error';
import Success from './Success';

/*
 * Steps to verify
 * 1. Scan varcode on shippo label
 * 2. Item details will appear
 * 3. when the barcode is scanned there will be an option to either verify or deny
 * 4. if verified, the shipping label to the 'toUser' (toSender or toReciever) will appear
 * 5. 
 */

const Verify = () => {
    const [trackingNum, setTrackingNum] = useState('');
    const [order, setOrder] = useState(undefined);
    const handleChange = e => setTrackingNum(e.target.value);

    const [labelUrl, setLabelUrl] = useState('');

    const [products, setProducts] = useState([]);

    const [error, setError] = useState('');
    const [success, setSuccess] = useState(false);

    const handleGetOrder = () => {
        getOrderFromTracking(trackingNum).then(orderData => {
            console.log(orderData);
            if (orderData.error) {
                console.log(orderData.error);
                setError(orderData.error);
            }
            else {
                setOrder(orderData);
                
                findManyProducts([orderData.recieverItemId, ...orderData.senderItemIds]).then(productsData => {
                    setProducts(productsData);
                    console.log('prodcs');
                    console.log(productsData);
                });
            }
        });
    };

    const { user: {_id}, token } = isAuthenticated();

    const handleAccept = e => {
        const product = JSON.parse(e.target.value);
        console.log(product.userId);
        acceptVerify(order._id, _id, product.userId, token).then(newLabelUrl => {
            if (newLabelUrl.error) {
                setError(newLabelUrl.error);
            }
            else {
                setSuccess(true);
                setLabelUrl(newLabelUrl);
            }
            
        });
    };

    const handleDecline = e => {
        const product = JSON.parse(e.target.value);
        denyVerify(order._id, _id, product.userId, token).then(response => {
            if (response.error) {
                setError(response.error);
                return;
            }
            console.log(response);
        });
    };

    const AcceptOrDeny = ({product}) => (
        <>
            <button
                value={JSON.stringify(product)}
                onClick={handleAccept}
                type="button"
                className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500"
            >
                Accept
            </button>
            <br/>

            <button
                value={JSON.stringify(product)}
                onClick={handleDecline}
                type="button"
                className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 mt-4"
            >
                Deny
            </button>

        </>
    )
    
    const OrderDetails = () => (
        <>
            {products.map((product, i) => (
                <>
                    {product.name}
                    <img src={`${API}/static/product_photos/${product.primary_photo}`} className='w-96'/>
                    <AcceptOrDeny product={product}/>
                </>
            ))}
        </>
    );

    return (
        <Layout>
            {error &&
            <Error error={error}/>
            }
            {success && 
                <Success label_url={labelUrl}/>
            }

            <h1> Scan barcode (or enter tracking number manually) </h1>
            <input type='text' onChange={handleChange}/>

            <button onClick={handleGetOrder}> Get Order </button>
            
            <br/>
            {order &&
                <>
                    <OrderDetails/>
                    <br/>
                </>
            }
            
            <br/>
            <h1 className='font-bold'> New label </h1>
            <a href={labelUrl}> {labelUrl} </a>

        </Layout>
    );
};

export default Verify;
